<template>
  <!-- 页面容器 -->
  <div
    class="page-container"
  >
    <div>
      <!-- 页面头部 -->
      <div>
        <div
          class="page-card__header"
        >
          <span style="padding-right: 20px"> 反馈信息</span>
        </div>
      </div>
      <!-- 数据表格 -->
      <el-table :data="tableData" style="width: 100%; padding: 0 20px">
        <el-table-column prop="id" label="ID" width="80"> </el-table-column>
        <el-table-column prop="contact" label="联系方式" width="120">
        </el-table-column>
        <el-table-column prop="content" label="内容"> </el-table-column>

        <el-table-column prop="type" label="来源" width="120">
          <template slot-scope="scope">
            <span v-if="scope.row.type === 1">小程序</span>
            <span v-else>展商</span>
          </template>
        </el-table-column>

        <el-table-column prop="create_time" label="发布时间" width="160">
        </el-table-column>
        <el-table-column label="状态" width="100">
          <template slot-scope="scope">
            <span v-if="scope.row.read === 1" style="color: #42b983">已读</span>
            <span v-else @click="handleClick(scope.row)" style="color: red"
              >未读</span
            >
          </template>
        </el-table-column>
        <!-- 操作列 -->
        <el-table-column fixed="right" label="操作" width="130">
          <template slot-scope="scope">
            <el-button
              v-if="scope.row.read === 0"
              type="text"
              @click="updateClick(scope.row)"
            >未读
            </el-button>
            <el-button
              v-else
              type="text"
              @click="updateClick_a(scope.row)"
            >已读
            </el-button>
            <el-button
              type="text"
              class="action-btn--danger"
              @click="handleClick(scope.row)"
            >删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <div class="pagination-wrap">
        <el-pagination
          @current-change="handleCurrentChange"
          :page-size="pagesize"
          :total="aSum"
          :page-count="pageCount"
          :current-page.sync="currentPage"
          background
          layout="prev, pager, next,jumper"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import api from "../../utils/api";

export default {
  data() {
    return {
      changetype: true,
      changeID: 0,
      tableData: [],
      //分页
      // 总条目数 total
      aSum: 0,
      // 当前页数 currenr_page
      currentPage: 1,
      // 总页数 num_pages
      pageCount: 1,
      // 每页显示条目数 pagesize
      pagesize: 10,
    };
  },
  mounted() {
    this.getInfo();
  },

  methods: {
    // 获取反馈信息列表数据
    getInfo() {
      let url = this.baseUrl + "/admin/messages/?ordering=-create_time&type=1";
      api.fetchData(url).then((res) => {
        this.tableData = res.results;
        this.aSum = res.count;
        this.currentPage = 1;
      });
    },

    // 分页切换
    handleCurrentChange(val) {
      let url = this.baseUrl + "/admin/messages/?ordering=-create_time&page=" + val;
      api.fetchData(url).then((res) => {
        this.tableData = res.results;
        this.aSum = res.count;
        this.currentPage = val;
      });
    },

    // 切换页面类型
    changePage() {
      this.changetype = true;
    },
    // 切换到命中页面
    changePage_hit() {
      this.changetype = false;
    },

    // 删除反馈信息
    handleClick(row) {
      this.$confirm("将删除此条信息，是否继续", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let id = row.id;
        let url = this.baseUrl + "/admin/messages/" + id + "/";
        api.deleteData(url).then((res) => {
          this.$message({
            message: "删除成功",
            type: "success",
          });
          this.getInfo();
        });
      });
    },

    // 标记反馈为已读
    updateClick(row) {
      let id = row.id;
      let url = this.baseUrl + "/admin/messages/" + id + "/";
      api
        .patchData(url, {
          read: 1,
        })
        .then((res) => {
          this.getInfo();
        });
    },

    // 标记反馈为未读
    updateClick_a(row) {
      let id = row.id;
      let url = this.baseUrl + "/admin/messages/" + id + "/";
      api
        .patchData(url, {
          read: 0,
        })
        .then((res) => {
          this.getInfo();
        });
    },
  },
};
</script>

<style scoped>
.changtype {
  background-color: var(--color-primary);
  color: white;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/newList.vue